import styled from "styled-components";

export const PersonalInfoFormStyled = styled.div`
  .input_wrap {
    margin-bottom: 18px;
    &.mb_32 {
      margin-bottom: 32px;
    }
  }
  .btn_next {
    margin: auto;
    max-width: 215px;
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .btn_next {
      max-width: 170px;
    }
  }
`;
